import Loadable from 'components/Loadable';
import {ENABLE_REGISTRATION} from 'configs/enable-features';
import {Redirect} from 'react-router';
import {useParams} from 'react-router';
import urlJoin from 'url-join';

const register = {
  path: '/register',
  component: Loadable({
    loader: () => import('../views/register'),
  }),
  routes: [
    {
      exact: true,
      path: '/register',
      component: () => <Redirect to="/register/user" />,
    },
    {
      exact: true,
      path: ['/register/user/(verified)?', '/register/user/:ceToken?'],
      component:
        ENABLE_REGISTRATION &&
        Loadable({
          loader: () => import('../views/register/user'),
        }),
    },
    {
      exact: true,
      path: '/register/accreditation-body',
      component: Loadable({
        loader: () => import('../views/register/accreditation-body'),
      }),
    },
    {
      exact: true,
      path: '/register/certification-body',
      component: Loadable({
        loader: () => import('../views/register/certification-body'),
      }),
    },
    {
      exact: true,
      path: '/register/certified-entity/:token?',
      component: () => {
        const {token} = useParams();

        let url;
        if (token) url = urlJoin('/register/user', token);
        else url = '/register/user';

        return <Redirect to={url} />;
      },
    },
  ],
};

export default register;
